import React, { lazy, useEffect, useState } from 'react'
import './App.css';
import { BrowserRouter as Router, Navigate, Route, Routes, useNavigate, Outlet, useLocation } from 'react-router-dom'
import { themeChange } from 'theme-change'
import { checkSession, logout } from './app/auth';
import { fbAuth } from "./app/firebase";
import initializeApp from './app/init';
import { useIdleTimer } from "react-idle-timer";

import { onAuthStateChanged } from 'firebase/auth';
import Loader from "./components/Loader/Loader"
import { useRole } from './services/users/useRoles';

// Initializing different libraries
initializeApp();

function App() {
  const { user: firestoreUser, isAffiliate } = useRole()
  const [currentUid, setCurrentUid] = useState(null);
  const [loggedOut, setLoggedOut] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const location = useLocation();

  const onIdle = async () => {
    setCurrentUid(null);
    setLoggedOut(true);
    await logout();
  };

  const { getRemainingTime } = useIdleTimer({
    onIdle,
    // onActive,
    // onAction,
    timeout: 1000 * 60 * 60 * 12, /* 12 hr */
    throttle: 500
  })

  useEffect(() => {
    // 👆 daisy UI themes initialization
    themeChange(false);
    
    const unsub = onAuthStateChanged(fbAuth, async (user) => {
      setCurrentUid(user ? user.uid : null);
      if (!user) {
        navigate('/login');
      }
      else {
        const validSession = await checkSession();
      }
      setIsLoading(false);
    });
    
    if (currentUid) {
      return () => {
        unsub();
      };
    }

  }, []);

  useEffect(() => {
    if (!currentUid || !firestoreUser) return;

    const currentPath = location.pathname;
    const isOnSettingsProfile = currentPath.startsWith('/app/settings-profile');
    const isAffiliateNeedingSetup =
      isAffiliate &&
      (!firestoreUser.defaultCompanyId || firestoreUser.defaultCompanyId === 0);

    // Only redirect if affiliate needs to set company
    if (isAffiliateNeedingSetup && !isOnSettingsProfile) {
      navigate('/app/settings-profile');
    }

    // ✅ no other redirect
  }, [currentUid, firestoreUser, isAffiliate, location.pathname]);
  
  

  if (error.length) return (<><div>Error: <span>{error}</span></div></>);
  if (isLoading) return (<>Loading... <Loader /></>);

  return (
    <>
      <Outlet />
    </>
  )
}

export default App
